module.exports = __webpack_public_path__ + "static/media/rectangle-1.82288a76.svg";